module.exports = __webpack_public_path__ + "static/media/whats.180b9525.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whats.png
// module id = 7
// module chunks = 0